import { Turbo } from "@hotwired/turbo-rails"

// Cross-origin Checkout can't be a Turbo redirect. A stream action does a
// real top-level navigation after Book now holds the seat.
Turbo.StreamActions.redirect = function () {
  const url = this.target
  if (url) window.location.assign(url)
}
